/**
 |--------------------------------------------------------------------------
 | TASKS : Vue-Router Routes
 |--------------------------------------------------------------------------
 */
const tasks = [
 {
  path: '/tasks', component: require('pages/tasks/tasks.vue').default,
  name: 'tasks',
  meta: {requiresAuth: true, title: "Tasks", icon: "fas fa-tasks"}
 }, {
  path: '/tasks/create', component: require('pages/tasks/create.vue').default,
  name: 'create_task',
  meta: {requiresAuth: true, title: "New Task", icon: "fas fa-plus-square"}
 },
];
export default tasks;
